import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input, OnDestroy, OnInit } from '@angular/core';

import { AccordionComponent } from '../accordion/accordion.component';

/**
 * Accordion bindings:
 * accordionTitle: accordion title
 *   memoryId: accordion id, for saving state in Storage
 *   memoryLocation: accordion location, for saving state in Storage
 *   inner: used for second level accordion,
 *   card: used for ng-class .page-inner-container (second level accordions with odds-cards),
 *   trackLabel: used for GA, on VIP page,
 *   trackCategory: used for GA, on VIP page,
 *   isExpanded: used for toogle function,
 *   render: used for ng-if instead of ng-show,
 *   disabled: used to disable expand / collapse,
 *   function: callback needed for $timeout when two way data binding in completed,
 */
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'accordion',
    templateUrl: 'accordionSA.component.html',
    styleUrls: ['accordionSA.component.scss'],
    imports: [CommonModule],
})
export class AccordionSAComponent extends AccordionComponent implements OnInit, OnDestroy {
    @Input() isDesktop?: boolean = false;
}
